import PropTypes from "prop-types"
import StoredField from "app/components/stored_field/index"
import InlineErrors from "shared/components/inline_errors"
import { ingredientsMetadataShape } from "app/lib/shared_prop_types"
import {
  appletFieldShape,
  stepFieldShape,
} from "partners/components/shared/shared_prop_types"

export function VisibilityInput({
  appletField,
  field,
  onChange,
  disabled,
  errors,
}) {
  const choices = [
    ["hidden", "Set by you", appletField.hidden],
    ["visible", "Customizable by the user", !appletField.hidden],
  ]

  return (
    <div className="composer-tanda-field-input composer-tanda-field-visibility">
      <div className="label">
        <label>Visibility</label>
      </div>
      <InlineErrors errors={errors} />
      <div className="composer-tanda-field-visibility-choices">
        {choices.map(([value, label, isChecked]) => (
          <div className="radio input" key={value}>
            <input
              type="radio"
              value={value}
              id={`${field.stored_field.id}-${value}`}
              checked={isChecked}
              disabled={disabled}
              onChange={e =>
                onChange(appletField, { hidden: e.target.value === "hidden" })
              }
            />
            <label
              htmlFor={`${field.stored_field.id}-${value}`}
              onClick={() =>
                !disabled &&
                onChange(appletField, { hidden: value === "hidden" })
              }
            >
              {label}
            </label>
          </div>
        ))}
      </div>
      {!field.hideable && (
        <div className="note">This field must be chosen by the user.</div>
      )}
    </div>
  )
}

VisibilityInput.propTypes = {
  appletField: appletFieldShape,
  field: stepFieldShape,
  onChange: PropTypes.func,
  disabled: PropTypes.bool,
  errors: PropTypes.array,
}

export function CustomLabelInput({ appletField, field, onChange, errors }) {
  const disabled = appletField.hidden
  let value = appletField.custom_label || field.label

  return (
    <div className="composer-tanda-field-input">
      <div className="label">Field label</div>
      <InlineErrors errors={errors} />
      <div className="input">
        <input
          type="text"
          placeholder={field.label}
          disabled={disabled}
          value={value}
          onChange={e => {
            onChange(appletField, {
              custom_label:
                e.target.value === field.label ? null : e.target.value,
            })
          }}
          onBlur={() => {
            if (
              appletField.custom_label !== null &&
              !appletField.custom_label.trim()
            ) {
              onChange(appletField, { custom_label: null })
            }
          }}
        />
      </div>
    </div>
  )
}

CustomLabelInput.propTypes = {
  appletField: appletFieldShape,
  field: stepFieldShape,
  onChange: PropTypes.func,
  errors: PropTypes.array,
}

export function DefaultValueInput({
  showLabel,
  appletField,
  field,
  ingredientsMetadata,
  platformComposer,
  onChange,
  onInvalidResolution,
  resolveError,
  errors,
  disabled,
}) {
  if (resolveError) {
    return (
      <div className="composer-tanda-field-input">
        <div className="error">
          Sorry, we weren&apos;t able to load the options for this field. Please
          contact our Developer Support team if the problem persists.
        </div>
      </div>
    )
  }

  // Users shouldn't see anything about default_values or hidden
  // fields if they are being shown the tanda field minimal view
  const translateErrorsForMinimalView = errors => {
    if (!errors.length) return errors

    Object.keys(errors).map(k => {
      return (errors[k] = errors[k]
        .replace(/^(default value|value)/gi, field.label)
        .replace("and hidden", ""))
    })

    return errors
  }

  return (
    <div className="composer-tanda-field-input">
      {showLabel && (
        <div className="label">
          <label>{appletField.hidden ? "Value" : "Default value"}</label>
        </div>
      )}
      <InlineErrors
        errors={showLabel ? errors : translateErrorsForMinimalView(errors)}
      />
      <div className="input">
        <StoredField
          field={field.stored_field}
          fieldName=""
          fieldOwnerServiceName="This service"
          value={appletField.default_value}
          ingredientsMetadata={ingredientsMetadata}
          platformComposer={platformComposer}
          onReady={() => {}}
          onChange={value => onChange(appletField, { default_value: value })}
          onInvalidResolution={error => onInvalidResolution(field, error)}
          disabled={disabled}
          userAllowMultipleLiveChannels={false}
        />
      </div>
    </div>
  )
}

DefaultValueInput.propTypes = {
  appletField: appletFieldShape,
  field: stepFieldShape,
  ingredientsMetadata: ingredientsMetadataShape,
  showLabel: PropTypes.bool,
  platformComposer: PropTypes.bool.isRequired,
  onChange: PropTypes.func,
  onInvalidResolution: PropTypes.func,
  resolveError: PropTypes.bool,
  errors: PropTypes.array,
  disabled: PropTypes.bool,
}
